"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var index_1 = __importDefault(require("../components/wallet/index"));
var loop_wallet_1 = require("../Loop_Reuseable_Component/packages/loop_wallet");
var react_i18next_1 = require("react-i18next");
var i18next_1 = require("i18next");
var check_svg_1 = __importDefault(require("../../staticAssets/check.svg"));
var logo_png_1 = __importDefault(require("../../staticAssets/logo.png"));
function LoginModal(props) {
    var open = props.open, close = props.close, showSignup = props.showSignup, setShowSignUp = props.setShowSignUp;
    var address = (0, loop_wallet_1.useWallet)().address;
    var checkList = (0, i18next_1.t)("signupCheckList");
    (0, react_1.useEffect)(function () {
        // Update signupForm state when showSignup prop changes
        setShowSignUp(showSignup);
    }, [showSignup]);
    //close modal
    (0, react_1.useEffect)(function () {
        if (open && address) {
            close();
        }
    }, [address]);
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Modal, __assign({ size: "mini", open: open, onClose: close, className: "mainModal" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: logo_png_1.default, className: "modalLogo" }), showSignup ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "modalTitle" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "signupTitle" }) })), (0, jsx_runtime_1.jsx)("p", { children: "Get free access to explore VIP Clubs and special benefits" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "SignupChecklist" }, { children: [(0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("img", { src: check_svg_1.default }), " ", checkList[0]] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("img", { src: check_svg_1.default }), " ", checkList[1]] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("img", { src: check_svg_1.default }), " ", checkList[2]] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("img", { src: check_svg_1.default }), " ", checkList[3]] })] })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {})] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "modalTitle" }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "loginTitle" }) })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {})] })), (0, jsx_runtime_1.jsx)(index_1.default, { showSignup: showSignup, setSignupform: setShowSignUp })] })));
}
exports.default = LoginModal;
